import {
    Component,
    Input, OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { SubscriptionModel } from '../../shared/models/subscription.model';
import { CommonHttpService } from '../../shared/services/http.service';
import { DialogRef, OverlayContext } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ClientModel } from '../../shared/models/client.model';
import { DeliveryStepsService } from '../../payment/services/delivery-steps.service';
import { ZipCodeRangeModel } from '../../shared/models/zip-code-range.model';
import { ResumeUpdaterService } from '../services/cart-resume-updater.service';
import { CurrencyPipe } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'cart-subscriptions-update',
    templateUrl: './cart.subscriptions-update.component.html',
    styleUrls: ['./../cart.component.scss']
})
export class CartSubscriptionsUpdateComponent implements OnInit, OnDestroy {
    @Input('subscriptions') subscriptions: Array<SubscriptionModel> = [];
    @Input('client') client: ClientModel;
    @ViewChild('templateRef') public templateRef: TemplateRef<any>;

    private updatingDialogRef: DialogRef<any>;

    protected freightRecalculated = false;
    protected selectedFreight: ZipCodeRangeModel;
    protected freights: Array<ZipCodeRangeModel> = [];
    protected subscriptionToUpdate: SubscriptionModel;
    protected overlayContext = new OverlayContext();
    protected deliverable = false;

    public total = '0';

    deliveryStepsLoadedFreights: Subscription;
    deliveryStepsSelectedFreight: Subscription;
    resumeUpdaterServiceIndexed: Subscription;

    constructor(
        protected resumeUpdaterService: ResumeUpdaterService,
        protected modal: Modal,
        protected http: CommonHttpService,
        protected translate: TranslateService,
        protected deliverySteps: DeliveryStepsService,
        protected currency: CurrencyPipe
    ) { }

    ngOnInit() {
        this.deliveryStepsLoadedFreights = this.deliverySteps.loadedFreights$.subscribe(() => {
            this.freights = this.deliverySteps.getFreights();
        });
        this.deliveryStepsSelectedFreight = this.deliverySteps.selectedFreight$.subscribe(() => {
            this.freightRecalculated = true;
        });
        this.resumeUpdaterServiceIndexed = this.resumeUpdaterService.indexed$
            .subscribe((index: any) => {
                this.total = this.currency.transform(index.total, 'BRL', true, '1.2-2');
            });
    }
    ngOnDestroy() {
        // Overrided by AutoUnsubscribe
    }

    /**
     * Open confirmation modal and load all freight options to recalculate.
     **/
    public change(subscription: any) {
        if (subscription.deliveries.address !== undefined) {
            this.deliverable = true;
            this.deliverySteps.setSelectedAddress(subscription.deliveries.address);
            this.deliverySteps.loadFreights().subscribe();
        }

        this.subscriptionToUpdate = subscription;
        this.modal
            .open(this.templateRef, {context: this.overlayContext})
            .then();
    }
    /**
     * Confirm change and call api to update.
     **/
    public confirm(dialogRef: DialogRef<any>) {
        dialogRef.close();

        this.update();
        this.updatingModal();
    }
    /**
     * Set to delivery steps service choosed freight option to call api.
     **/
    public calculateFreight(freight) {
        this.selectedFreight = freight;
        this.deliverySteps.setSelectedFreight(freight);
    }
    /**
     * Return if freight instance is equal to selected freight instance.
     **/
    public isSelectedFreight(freight: ZipCodeRangeModel) {
        return this.freightRecalculated
            && null !== freight
            && null !== this.selectedFreight
            && this.selectedFreight.id === freight.id;
    }

    /**
     * Send a request to api to update subscription with cart items.
     **/
    private update() {
        this.http
            .useAuth()
            .mustBeBlessed()
            .put(
                `/account/clients/${this.client.id}`
                + `/subscriptions/${this.subscriptionToUpdate.id}`
                + `/recurrent-cart`,
                {id: this.subscriptionToUpdate.id}
            )
            .subscribe(() => {
                this.updatedModal();
            }, () => {
                this.errorModel();
            });
    }
    /**
     * Configure and open updating modal.
     **/
    private updatingModal() {
        this.translate.get([
            'CART.UPDATE_SUBSCRIPTION.UPDATING_MODAL.TITLE',
            'CART.UPDATE_SUBSCRIPTION.UPDATING_MODAL.BODY'
        ]).subscribe((translated: string) => {
            this.modal
                .alert()
                .titleHtml(
                    '<h3>' +
                    '<i class="fa fa-circle-o-notch fa-spin"></i> ' +
                    translated['CART.UPDATE_SUBSCRIPTION.UPDATING_MODAL.TITLE'] +
                    '</h3>'
                )
                .keyboard(1)
                .body(translated['CART.UPDATE_SUBSCRIPTION.UPDATING_MODAL.BODY'])
                .isBlocking(true)
                .okBtnClass('')
                .dialogClass('modal-dialog updating-subscription success without-footer')
                .showClose(false)
                .open()
                .then(dialog => {
                    this.updatingDialogRef = dialog;
                });
        });
    }
    /**
     * Configure and open successful update modal.
     **/
    private updatedModal() {
        this.updatingDialogRef.close();
        this.translate.get([
            'CART.UPDATE_SUBSCRIPTION.UPDATED_MODAL.TITLE',
            'CART.UPDATE_SUBSCRIPTION.UPDATED_MODAL.BODY'
        ]).subscribe((translated: string) => {
            this.modal
                .alert()
                .titleHtml(`<h3><i class="fa fa-check-circle-o"></i> ${translated['CART.UPDATE_SUBSCRIPTION.UPDATED_MODAL.TITLE']}</h3>`)
                .keyboard(1)
                .body(translated['CART.UPDATE_SUBSCRIPTION.UPDATED_MODAL.BODY'])
                .isBlocking(true)
                .dialogClass('modal-dialog subscription-updated success')
                .showClose(false)
                .open()
                .then();
        });
    }
    /**
     * Configure and open error update modal.
     **/
    private errorModel() {
        this.updatingDialogRef.close();
        this.translate.get([
            'CART.UPDATE_SUBSCRIPTION.UPDATE_ERROR_MODAL.TITLE',
            'CART.UPDATE_SUBSCRIPTION.UPDATE_ERROR_MODAL.BODY'
        ]).subscribe((translated: string) => {
            this.modal
                .alert()
                .titleHtml(`<h3>${translated['CART.UPDATE_SUBSCRIPTION.UPDATE_ERROR_MODAL.TITLE']}</h3>`)
                .keyboard(1)
                .body(translated['CART.UPDATE_SUBSCRIPTION.UPDATE_ERROR_MODAL.BODY'])
                .isBlocking(true)
                .dialogClass('modal-dialog update-error')
                .showClose(true)
                .open()
                .then();
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/cart/subscriptions-update/cart.subscriptions-update.component.ts